import { useState } from "react";
import { Theme } from "../component/navigation/ThemeDropdown";

export default function ThemeIcon({ theme }: { theme: Theme }) {
    const [isSelected, setIsSelected] = useState(false);

    const handleClick = () => {
        setIsSelected(!isSelected);
    };

    return (
        <div onClick={handleClick} style={{ cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 23.9969C18.6274 23.9969 24 18.625 24 11.9985C24 5.3719 18.6274 0 12 0C5.37259 0 0 5.3719 0 11.9985C0 18.625 5.37259 23.9969 12 23.9969Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M5.28244 11.9984C5.28244 15.7079 8.29007 18.7151 12 18.7151V5.28479C8.29007 5.28479 5.28244 8.29204 5.28244 12.0015V11.9984Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M12 5.28479V18.7151C15.7099 18.7151 18.7176 15.7079 18.7176 11.9984C18.7176 8.28899 15.7099 5.28174 12 5.28174V5.28479Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                <path
                    d="M12 5.8954C15.3893 5.8954 18.1435 8.6523 18.1435 12.0381C18.1435 15.424 15.3863 18.1809 12 18.1809C8.61376 18.1809 5.85651 15.424 5.85651 12.0381C5.85651 8.6523 8.61376 5.8954 12 5.8954ZM12 5.28479C8.26872 5.28479 5.24582 8.30731 5.24582 12.0381C5.24582 15.769 8.26872 18.7915 12 18.7915C15.7313 18.7915 18.7542 15.769 18.7542 12.0381C18.7542 8.30731 15.7313 5.28479 12 5.28479Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
